import React, {useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import IFrameWrapper from "../../components/IFrameWrapper";
import {APP_URL_PREFIX} from "../../utilities/Constants";

const BENCHMARK_DOMAIN = "https://question-bank-beta-a7neof6f-hsncks-dot-lugotest-hrd.appspot.com";

const Benchmark = () => {
    const {search} = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const handleMessage = (e) => {
            if (!e.data || e.data.type !== 'lugoNavigateToCandidate') return;
            navigate(APP_URL_PREFIX + "/candidate/" + e.data.candidateKey);
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [navigate]);

    return (
        <IFrameWrapper src={BENCHMARK_DOMAIN + "/Benchmark.htm" + search} width={"min(100%, 1470px)"} />
    );
};

export default Benchmark;
